import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";
import { Trash2 } from "lucide-react";

export default function AdminPromotions() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", starts_at: "", ends_at: "", active: true });

  const load = async () => {
    try { const { data } = await api.get("/admin/promotions"); setItems(data); }
    catch { toast.error("Could not load"); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/promotions", form);
      toast.success("Promotion created");
      setForm({ title: "", body: "", starts_at: "", ends_at: "", active: true });
      await load();
    } catch { toast.error("Failed"); }
  };

  const del = async (id) => {
    await api.delete(`/admin/promotions/${id}`);
    toast.success("Deleted");
    await load();
  };

  return (
    <div className="p-8 md:p-12">
      <div className="overline">Admin</div>
      <h1 className="font-serif-display text-4xl mt-2">Promotions</h1>

      <div className="mt-10 grid md:grid-cols-2 gap-8">
        <div className="border border-[#E2E8F0] bg-white p-8">
          <div className="overline">New promotion</div>
          <input data-testid={ADMIN.promoTitle} placeholder="Title" value={form.title}
                 onChange={(e) => setForm({ ...form, title: e.target.value })}
                 className="mt-4 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-3 outline-none"/>
          <textarea data-testid={ADMIN.promoBody} rows={3} placeholder="Body" value={form.body}
                    onChange={(e) => setForm({ ...form, body: e.target.value })}
                    className="mt-4 w-full border border-[#E2E8F0] focus:border-[#0F172A] bg-white p-3 outline-none"/>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label className="overline">Starts</label>
              <input data-testid={ADMIN.promoStart} type="datetime-local" value={form.starts_at}
                     onChange={(e) => setForm({ ...form, starts_at: new Date(e.target.value).toISOString() })}
                     className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-2 outline-none"/>
            </div>
            <div>
              <label className="overline">Ends</label>
              <input data-testid={ADMIN.promoEnd} type="datetime-local" value={form.ends_at}
                     onChange={(e) => setForm({ ...form, ends_at: new Date(e.target.value).toISOString() })}
                     className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-2 outline-none"/>
            </div>
          </div>
          <button data-testid={ADMIN.promoSave} onClick={save}
                  className="mt-6 px-6 py-3 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F]">
            Publish
          </button>
        </div>

        <div className="space-y-4">
          {items.map(p => (
            <div key={p.id} className="border border-[#E2E8F0] bg-white p-6">
              <div className="flex justify-between items-start gap-4">
                <div>
                  <div className="font-serif-display text-2xl">{p.title}</div>
                  <p className="text-sm text-[#4A4A4A] mt-2">{p.body}</p>
                  <div className="overline mt-3">{new Date(p.starts_at).toLocaleDateString()} → {new Date(p.ends_at).toLocaleDateString()}</div>
                </div>
                <button onClick={() => del(p.id)} className="text-[#0F172A] hover:text-[#B8941F]">
                  <Trash2 size={18}/>
                </button>
              </div>
            </div>
          ))}
          {items.length === 0 && <div className="text-[#4A4A4A] text-sm">No promotions yet.</div>}
        </div>
      </div>
    </div>
  );
}
